import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'getCampaignIndividualEmails'

export default (campaignId) => (asyncAction(
  name,
  CampaignsService.getCampaignIndividualEmails,
  { campaignId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/getCampaignIndividualEmails.js